const OurMission = () => {
  return (
    <section
      id="mission"
      className="section-padding bg-image overlay-dark dark-bg text-center"
      style={{
        backgroundImage:
          "linear-gradient(135deg, #1a2230 0%, #111826 55%, #0d121b 100%)",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed",
        position: "relative",
        color: "#fff",
      }}
    >
      {/* Overlay for readability */}
      <div
        style={{
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 1,
        }}
      ></div>

      <div className="container" style={{ position: "relative", zIndex: 2 }}>
        <h3>Our Mission</h3>
        <p className="lead">
          Every small business owner who is working hard, delivering quality,
          and building something real - deserves to be found online. Not
          someday. Now. <br />
          <br />
          We believe the gap between a business running on WhatsApp and a
          business with a professional online store should not come down to
          budget, technical knowledge, or access to the right people. It should
          come down to one decision - the decision to start. <br />
          <br /> At Sarentu, we exist to make that decision easy. And everything
          after it - easier.
        </p>
        <a href="#contact-us" className="btn btn-md btn-color">
          GET IN TOUCH
        </a>
      </div>
    </section>
  );
};

export default OurMission;
